<template>
    <div id="view-controls">
        <ShowSemiFullscreenButton />
        <ShowFullscreenButton />
        <BackgroundColorPicker class="mx-5" />

        <ScopesButton :class="{'v-btn--active': scopesEnabled}" />
        <GamutCompressButton :class="{'v-btn--active': gamutCompression && !IDT.initial}" />
        <FixBlueLightButton class="hide" />
    </div>
</template>

<script>
import ShowSemiFullscreenButton from "@/components/app/buttons/ShowSemiFullscreenButton.vue";
import ShowFullscreenButton from "@/components/app/buttons/ShowFullscreenButton.vue";
import BackgroundColorPicker from "@/components/app/ui/BackgroundColorPicker.vue";
import ScopesButton from "@/components/app/buttons/ScopesButton.vue";
import FixBlueLightButton from "@/components/app/buttons/FixBlueLightButton.vue";
import GamutCompressButton from "@/components/app/buttons/GamutCompressButton.vue";
import { mapState } from "vuex";

export default {
    components: {
        GamutCompressButton,
        FixBlueLightButton,
        ScopesButton,
        ShowSemiFullscreenButton, ShowFullscreenButton, BackgroundColorPicker
    },
    computed: {
        ...mapState('Scopes', ['scopesEnabled']),
        ...mapState('UI', ['gamutCompression']),
        ...mapState('App', ['IDT']),
    }
}
</script>

<style lang="scss" scoped>
#view-controls {
    display: flex;
    align-items: center;
    gap: 5px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
</style>